import { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./MobileBottomBar.module.scss";
import { CartContext } from "../../Contexts/CartContext";
import { AuthContext } from "../../Contexts/AuthContext";

const MobileBottomBar = ({ setMobileSearch, mobileSearch }) => {
    const location = useLocation();
    const { cartItems } = useContext(CartContext);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.querySelector("body").scrollTo(0, 0);
    }, [mobileSearch]);

    const isAccountActive = () => {
        return location.pathname === "/forgot-password" || location.pathname === "/customer/account";
    }

    return (
        <div id="mobile-bottom-bar" className={styles.mobileBottomBar}>
            <ul>
                <li>
                    <Link to={"/"} className={location.pathname === "/" ? styles.active : null}>
                        <img src="/icon/mbb/home.svg" alt="" />
                        <span>Home</span>
                    </Link>
                </li>
                <li>
                    <Link
                        to={"/categories"}
                        className={location.pathname === "/categories" || location.pathname.includes("/category") ? styles.active : null}
                    >
                        <img src="/icon/mbb/category.svg" alt="" />
                        <span>Categories</span>
                    </Link>
                </li>
                <li style={{ position: "relative" }}>
                    {cartItems.length > 0 && <span className={styles.count}>{cartItems.length}</span>}

                    <Link to={"/cart-checkout"}
                        className={location.pathname === "/cart-checkout" || location.pathname.includes("/category") ? styles.active : null}
                    >
                        <img src="/icon/mbb/cart.svg" alt="" />
                        <span>My Cart</span>
                    </Link>
                </li>
                <li>
                    {/* <Link to={"/customer/lists"}>
                        <img src="/icon/mbb/list.svg" alt="" />
                        <span>My List</span>
                    </Link> */}
                    <Link to={"/search"} className={location.pathname === "/search" ? styles.active : null}>
                        <img src="/icon/search-grey.svg" alt="Search icon" />
                        <span>Search</span>
                    </Link>
                </li>
                <li>
                    {/* <Link to={"/customer/coupons"} className={location.pathname === "/customer/coupons" ? styles.active : null}>
                        <img src="/icon/mbb/discount.svg" alt="" />
                        <span>Discounts</span>
                    </Link> */}

                    <Link to={"/customer/account"} className={isAccountActive() ? styles.active : null}>
                        {user.dp ? (
                            <>
                                <img src={user.dp} alt="dp" className="rounded-circle object-fit-cover" />
                                <span>Account</span>
                            </>
                        ) : (
                            <>
                                <img src={"/icon/account.svg"} alt="placeholder_img" />
                                <span>Account</span>
                            </>
                        )}
                    </Link>
                </li>

            </ul>
        </div>
    );
};

export default MobileBottomBar;
